// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3rVLx","label":"SetPasswdForm_label__2Mpf0"};